module.exports = __webpack_public_path__ + "assets/img/btn-view-bcc1316d.png";